// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1NuYV","col":"styles_col__1O6-K"};